// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1CMuS","text":"SelectPayment_text__gkD8J","title":"SelectPayment_title__2oTKk","btn":"SelectPayment_btn__NQ1yE"};